import { render, staticRenderFns } from "./InstructionSelector.vue?vue&type=template&id=4c0a204e&scoped=true"
import script from "./InstructionSelector.vue?vue&type=script&lang=js"
export * from "./InstructionSelector.vue?vue&type=script&lang=js"
import style0 from "./InstructionSelector.vue?vue&type=style&index=0&id=4c0a204e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0a204e",
  null
  
)

export default component.exports